import { UserProfilePageProps } from './user-profile-page.types'
import styles from './user-profile-page.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'
import {
  Button,
  EntityInfoNameLine,
  LabeledLine,
  PageContainer,
  PageHeader,
  SectionContainer,
  Text1,
  HorizontalLine,
  ImagePortrait,
  Select,
  GalleryDropZone,
  GalleryDropZoneRef
} from '@touche-lts/panel-ui/dist'
import {
  IconCalendar,
  IconEdit,
  IconEmail,
  IconUserManagement
} from 'assets/icons'
import { useRef } from 'react'
import { imgUrlToMediaContentDTO } from './user-profile-page.utils'
import { UserRoleDTO } from 'models'
import { StoresSection } from './stores-section'
import { ActionHistorySection } from 'components'

const UserProfilePageComponent = (props: UserProfilePageProps) => {
  const {
    className,
    style,
    match: {
      params: { userId }
    },
    history: { push }
  } = props

  const {
    userProfilePageStore: {
      loadUser,
      userFullName,
      onEditButtonClick,
      editMode,
      userImageUrl,
      user,
      userAddedOn,
      userRolesLabel,
      // onDeleteUserClick,
      onDiscardChangesClick,
      onSubmit,
      userRoleSelectOptions,
      selectedUserRole,
      setUserProps,
      validationErrors,
      fullName,
      setFullName,
      clearStore,
    },
    generalStore: {
      api: { uploadFileSigned }
    }
  } = useRootStore()

  useEffect(() => {
    loadUser(userId)
    return clearStore
  }, [loadUser, userId, clearStore])

  const gallery: GalleryDropZoneRef = useRef()

  const onSaveChangesClick = async () => {
    await gallery.current.handleImages()
    const images = gallery.current.getImages()
    const imageUrl = images?.[0]?.url || null
    setUserProps({ imageUrl })
    onSubmit()
  }

  if (!user) return null

  return (
    <PageContainer className={cl(styles.scrollable, className)} style={ {...style,  overflowX : "hidden" }}>
      <PageHeader
        navSegments={[
          {
            icon: IconUserManagement,
            label: `User management`,
            iconProps: { viewBox: '0 0 22 22' },
            onClick: () => push(`/user-management`)
          },
          {
            label: userFullName
          }
        ]}
      />
      <SectionContainer extraPaddingBottom>
        {!editMode && (
          <Button
            preset='icon'
            className={styles.editButton}
            title='Edit'
            onClick={onEditButtonClick}
          >
            <IconEdit />
          </Button>
        )}
        <EntityInfoNameLine
          editMode={editMode}
          imageProps={{ src: userImageUrl }}
          entityName={userFullName}
          onDiscardChangesClick={onDiscardChangesClick}
          onSaveChangesClick={onSaveChangesClick}
          nameInputProps={{
            placeholder: 'First and Last name',
            value: fullName,
            onChange: setFullName,
            errorMessage:
              validationErrors?.firstName?.[0] ||
              validationErrors?.lastName?.[0]
          }}
        />
        <LabeledLine
          labelIcon={IconEmail}
          label='Email'
          className={styles.labeledLine}
        >
          {/* {editMode ? (
            <Input
              placeholder='Email'
              value={user.emailAddress}
              onChange={emailAddress => setUserProps({ emailAddress })}
              autoComplete='email'
              autoCapitalize='none'
              type='email'
              errorMessage={validationErrors?.emailAddress?.[0]}
            />
          ) : ( */}
          <Text1>{user?.emailAddress}</Text1>
          {/* )} */}
        </LabeledLine>
        <LabeledLine
          labelIcon={IconCalendar}
          label='Add on'
          className={styles.labeledLine}
        >
          <Text1>{userAddedOn}</Text1>
        </LabeledLine>
        <LabeledLine label='Role' className={styles.labeledLine}>
          {editMode ? (
            <Select<UserRoleDTO>
              placeholder='Role'
              noNoneOption
              options={userRoleSelectOptions}
              value={selectedUserRole}
              onChange={role => setUserProps({ role })}
              errorMessage={validationErrors?.role?.[0]}
            />
          ) : (
            <Text1>{userRolesLabel}</Text1>
          )}
        </LabeledLine>

        {Boolean(user?.imageUrl || editMode) && (
          <>
            <HorizontalLine />
            <Text1 bold className={styles.labeledLine}>
              User image
            </Text1>
            <div className={styles.blockContainer}>
              {editMode ? (
                <GalleryDropZone
                  uploadFile={uploadFileSigned}
                  initialImages={
                    user.imageUrl
                      ? [imgUrlToMediaContentDTO(user.imageUrl)]
                      : []
                  }
                  dropzoneOptions={{ multiple: false }}
                  singleImage
                  noEditing
                  ref={gallery}
                />
              ) : (
                <ImagePortrait width={94} src={userImageUrl} />
              )}
            </div>
          </>
        )}
        {/* <Button
          preset='link'
          className={styles.deleteUserButton}
          title='Delete user'
          onClick={onDeleteUserClick}
        >
          <IconDeleteCircle />
          Delete user
        </Button> */}
      </SectionContainer>
      <StoresSection className={styles.sectionMarginTop} />
      <ActionHistorySection className={styles.sectionMarginTop} />
    </PageContainer>
  )
}

const UserProfilePage = observer(UserProfilePageComponent)
export { UserProfilePage }
